import { Sidebar } from "./sidebar";
import { cn } from "@/lib/utils";

interface MainLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function MainLayout({ children, className }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-background flex" data-testid="main-layout">
      <Sidebar />
      <div className="ml-72 min-w-0 flex-1">
        <main className={cn("min-h-screen min-w-0 w-full bg-gray-50", className)}>
          {children}
        </main>
      </div>
    </div>
  );
}

// Also export as default for compatibility
export default MainLayout;
